import { ONBOARDING_DIALOG_CLASS_NAME } from "@constants";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { DialogClasses, Drawer, DrawerClasses } from "kz-ui-sdk";
import { PropsWithChildren, useEffect, useRef } from "react";
import { DialogFullPage } from "./components";

interface DialogControllerProps extends PropsWithChildren {
  layout: _MemberSettingOnboardDialogLayout;
  isOpen: boolean;
  onClose: () => void;
  classes?: {
    drawer?: DrawerClasses["classes"];
    dialog?: DialogClasses["classes"];
  };
}

const DRAWER_APPEAR_DURATION = 300;

/**
 * This component is used to render the dialog or drawer based on the layout prop.
 */
const DialogLayoutRenderer = ({ children, layout, isOpen, onClose, classes }: DialogControllerProps) => {
  const openTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (isOpen && layout === _MemberSettingOnboardDialogLayout.DIALOG_DRAWER) {
      openTimeRef.current = Date.now();
    }
  }, [isOpen, layout]);

  // Prevent closing the drawer if it is opening
  const handleClose = () => {
    if (openTimeRef.current) {
      const timeSinceOpen = Date.now() - openTimeRef.current;
      if (timeSinceOpen >= DRAWER_APPEAR_DURATION) {
        onClose();
      }
    } else {
      onClose();
    }
  };

  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_DRAWER) {
    return (
      <Drawer
        open={isOpen}
        onClose={handleClose}
        safeZone
        classes={classes?.drawer}
        className={ONBOARDING_DIALOG_CLASS_NAME}
      >
        {children}
      </Drawer>
    );
  }

  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_PAGE) {
    return (
      <DialogFullPage
        open={isOpen}
        className={ONBOARDING_DIALOG_CLASS_NAME}
      >
        {children}
      </DialogFullPage>
    );
  }
};

export default DialogLayoutRenderer;
